// axios网络请求封装，带token刷新
import axios from 'axios'
import {
	baseURL,
	statusName,
} from '@/api/index.js'

import router from '@/router';
// import {
// 	toast
// } from './tools';

// import i18n from '@/lang';


// import {
// 	useUserStore
// } from '@/stores/user'

let refreshToking = false

let requests = []

/**
 * axios请求拦截器配置
 * @param config
 * @returns {any}
 */
const requestConf = (config) => {
	if (localStorage.getItem('token')) config.headers['Authorization'] = localStorage.getItem('token');
	// post请求需要使用form表单请求时,传递form参数
	if (config.type && config.type == 'form') {
		config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
		config.data = qs.stringify(config.data);
	}
	if (config.type && config.type == 'file') {
		config.headers['Content-Type'] = 'multipart/form-data';
	}
	// 如果是get请求，使用params
	if (config.method == 'get') {
		if (typeof(config.data) == 'string') {
			config.params = JSON.parse(config.data)
		} else {
			config.params = config.data
		}
	}
	// console.log('requestConf');
	return config
}

/**
 * 刷新刷新令牌
 * @param config 过期请求配置
 * @returns {any} 返回结果
 * 刷新token
 */
const tryRefreshToken = async (config) => {
	if (!refreshToking) {
		refreshToking = true
		try {
			const refresh = store.getters['user/refreshToken'];
			let data = null;
			return await refreshToken({
				refreshToken: refresh
			}).then(res => {
				if (res.success) {
					data = JSON.parse(res.data);
					const token = data.accessToken;
					if (token) {
						// 刷新成功重新缓存token
						store.dispatch('user/setToken', data).then(() => {})
						// 已经刷新了token，将所有队列中的请求进行重试
						requests.forEach((cb) => {
							cb(token)
						});
						requests = [];
						return instance(config);
					}
				} else {
					// 刷新token失败
					store.dispatch('user/resetAll').then(() =>
						router.push({
							path: '/login',
							replace: true
						}).then(() => {})
					)
					return res
				}
			}).catch(err => {
				// 刷新token失败
				store.dispatch('user/resetAll').then(() =>
					router.push({
						path: '/login',
						replace: true
					}).then(() => {})
				)
				return err
			})
		} finally {
			refreshToking = false
		}
	} else {
		return new Promise((resolve) => {
			// 将resolve放进队列，用一个函数形式来保存，等token刷新后直接执行
			requests.push(() => {
				resolve(instance(requestConf(config)))
			})
		})
	}
}

/**
 * axios响应拦截器
 * @param config 请求配置
 * @param data response数据
 * @param status HTTP status
 * @param statusText HTTP status text
 * @returns {Promise<*|*>}
 */
const handleData = async ({
	config,
	data,
	status,
	statusText
}) => {
	// 若data.code存在，覆盖默认code
	let code = data && data[statusName] ? data[statusName] : status
	switch (code) {
		// case 402:
		// 	return await tryRefreshToken(config)
		case 401:
			router.push({
				path: '/login',
				replace: true
			}).then(() => {})
			return
		case -1:
			const userStore = useUserStore();
			toast('登录状态失效，请重新登录', 'error')
			setTimeout(() => {
				userStore.layout();
			}, 800)
			// let errData = {
			// 	code: 0,
			// 	msg: i18n.global.t('tokenGuoqi')
			// }
			// return errData
			break
		default:
			return data
	}
	return Promise.reject(data);
}

/**
 * @description axios初始化
 */
const instance = axios.create()

/**
 * @description axios请求拦截器
 */
// instance.interceptors.request.use(requestConf, (error) => {
instance.interceptors.request.use((config) => requestConf(config), (error) => {
	return Promise.reject(error)
})

/**
 * @description axios响应拦截器
 */
instance.interceptors.response.use((response) => handleData(response), (error) => {
	const {
		response
	} = error
	if (response === undefined) {
		return {}
	}
	return handleData(response)
})

export default {
	get(url, data, options = {}) {
		options.url = baseURL + url
		options.data = data
		options.method = 'GET'
		return instance(options)
	},
	post(url, data, options = {}) {
		options.url = baseURL + url
		options.data = data
		options.method = 'POST'
		return instance(options)
	}
}